export default __webpack_public_path__ + "static/media/img17.20947ccc.jpg";